module.exports = __webpack_public_path__ + "img/128.b7371b8b.jpg";